'use client';
import { useEffect, useState } from 'react';
import { useTenant } from '@/app/context/TenantContext';

export default function TenantToast() {
  const { toast, brand, loading } = useTenant();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (loading || !toast?.attivo || !toast?.testo) return;
    if (toast.scade_il) {
      const oggi = new Date().toISOString().split('T')[0];
      if (oggi > toast.scade_il) return;
    }

    const key = 'toast_seen_count';
    const count = parseInt(localStorage.getItem(key) ?? '0');
    if (count >= 3) return;

    setVisible(true);
    localStorage.setItem(key, String(count + 1));
    setTimeout(() => setVisible(false), 12000);
  }, [loading, toast]);

  if (!visible) return null;

  const colorePrimario = brand?.colore_primario ?? '#f97316';
  const coloreTesto = brand?.colore_testo ?? '#ffffff';

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 max-w-sm w-full px-4">
      <div
        className="rounded-xl px-5 py-4 flex items-start gap-3 shadow-lg"
        style={{ backgroundColor: colorePrimario }}
      >
        <div className="flex-1 text-sm font-medium" style={{ color: coloreTesto }}>
          {toast?.testo}
        </div>
        <button
          onClick={() => setVisible(false)}
          className="text-lg leading-none mt-0.5 opacity-70 hover:opacity-100 transition-opacity"
          style={{ color: coloreTesto }}
        >
          ×
        </button>
      </div>
    </div>
  );
}